// Third-party
import React from 'react';

// Components
import CorrelationLegend from '../../../components/charts/correlation-chart/CorrelationLegend';

type Props = {
  label?: string;
};

const ComparisonCorrelationLabel: React.FunctionComponent<Props> = ({ label }: Props) => (
  <div className="comparison-correlation-label">
    <span className="correlation-field-label">{label}</span>

    <div className="correlation-legend-container">
      <CorrelationLegend />
    </div>
  </div>
);

export default ComparisonCorrelationLabel;
